import { render, staticRenderFns } from "./permissionsCompany.vue?vue&type=template&id=3f9edd5c&scoped=true&"
import script from "./permissionsCompany.vue?vue&type=script&lang=js&"
export * from "./permissionsCompany.vue?vue&type=script&lang=js&"
import style0 from "./permissionsCompany.vue?vue&type=style&index=0&id=3f9edd5c&prod&lang=less&scoped=true&"
import style1 from "./permissionsCompany.vue?vue&type=style&index=1&id=3f9edd5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9edd5c",
  null
  
)

export default component.exports